import { defaultResourceListPreferences } from '../components/ResourceList/contexts/defaultPreferences.js';

const mergeListPreferences = (preferences, data) => {
  return {
    ...defaultResourceListPreferences,
    ...preferences,
    ...data
  };
};

export { mergeListPreferences };
//# sourceMappingURL=mergeListPreferences.js.map
